import React from "react";

// locales
import i18n from '../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// vars
// import { SORT_ARRAY } from "../utils/const"

// style
import "./Sort.scss"

class Sort extends React.Component {

    // arr = i18n.t('sorting.array', { returnObjects: true });

    constructor(props) {
        super(props);
        this._onchangeHandler = props.onChange;
        this.state = {
            sort: i18n.t('sorting.array', { returnObjects: true })[0],
            sortArr: i18n.t('sorting.array', { returnObjects: true }),
        };

        // trace(this._onchangeHandler);
        // console.log(SORT_ARRAY);
    }

    handleChange(e) {
        e.preventDefault();
        // console.log(e);
        const value = e.currentTarget.dataset.value;
        console.log(value);
        this._onchangeHandler(value);
        this.setState({
            sort: value
        });
    }

    render() {
        return (
            <>
                <div className="sort-wrapper row align-items-center">
                    <div className="col-auto">
                        <p className="small float-right">{i18n.t('sorting.by')}</p>
                    </div>

                    <div className="col-auto">
                        <div className="dropdown">
                            <button className="btn btn-outline-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {this.state.sort}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                {
                                    this.state.sortArr.map((value, key) =>
                                        <a
                                            key={key}
                                            className="dropdown-item"
                                            // TODO: [mck] add active class
                                            data-value={value}
                                            href={"#" + value}
                                            onClick={(e) => this.handleChange(e)}>{value}</a>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(Sort);